require.ensure(
    ["./vue_search", "./bootstrap"],
    function(require) {
        window.$ = window.jQuery = require("jquery");
        require("./vue_search");
        require("./bootstrap");
    },
    "search_bootstrap"
);
